<app-accordion-info
  defaultSection="global"
  [mode]="uiFramework"
  [deviceInfo$]="settings$">
</app-accordion-info>

<ng-template
  #globalSetup
  let-data="data">
  <app-global-setup
    class="w-full"
    [mode]="uiFramework"
    [data]="data"
    (action)="execute($event)">
  </app-global-setup>
</ng-template>

<ng-template
  #timeSelector
  let-data="data"
  let-changeFn="changeFn">
  <app-date-time-selector
    mode="hour-minute"
    class="w-full"
    [uiFramework]="uiFramework"
    [value]="data"
    (valueChanged)="changeFn($event)">
  </app-date-time-selector>
</ng-template>

<ng-template
  #dateSelector
  let-data="data"
  let-changeFn="changeFn">
  <app-date-time-selector
    mode="month-day"
    class="w-full"
    [uiFramework]="uiFramework"
    [value]="data"
    (valueChanged)="changeFn($event)">
  </app-date-time-selector>
</ng-template>

<ng-template
  #weekdaySelector
  let-data="data"
  let-changeFn="changeFn">
  <app-weekday-selector
    class="w-full"
    [uiFramework]="uiFramework"
    [initialValue]="data"
    (valueChange)="changeFn($event)">
  </app-weekday-selector>
</ng-template>

<ng-template
  #inputChannelSelector
  let-data="data"
  let-changeFn="changeFn">
  <app-config-input-type-channel
    class="w-full"
    [uiFramework]="uiFramework"
    [info]="data"
    (valueChange)="changeFn($event)">
  </app-config-input-type-channel>
</ng-template>
